/**
 * tdesign-vue-chat v0.1.4
 * (c) 2024 tdesign
 * @license MIT
 */

import { Chat, ChatItem, ChatInput, ChatContent, ChatAI, ChatMofa, ChatAction } from '../chat/index.mjs';
import { ConfigProvider } from '../config-provider/index.mjs';

var components = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Chat: Chat,
	ChatItem: ChatItem,
	ChatInput: ChatInput,
	ChatContent: ChatContent,
	ChatAI: ChatAI,
	ChatMofa: ChatMofa,
	ChatAction: ChatAction,
	ConfigProvider: ConfigProvider
});

export { components as c };
//# sourceMappingURL=dep-2157ae50.mjs.map
